<template>
  <div class="instagram-feed-lightbox-root">
    <div
      v-if="visible && post"
      class="instagram-feed-lightbox"
      @click.self="close"
    >
      <div class="instagram-feed-lightbox__dialog" role="dialog" aria-modal="true">
        <button
          type="button"
          :aria-label="$t('ct-close')"
          class="instagram-feed-lightbox__close"
          @click.stop="close"
        >
          ×
        </button>
        <video
          v-if="videoSrc"
          ref="lightboxVideo"
          class="instagram-feed-lightbox__video"
          :src="videoSrc"
          :poster="imageSrc"
          controls
          playsinline
          preload="metadata"
          @click.stop
        />
        <img
          v-else
          class="instagram-feed-lightbox__image"
          :src="imageSrc"
          :alt="post.caption || 'Instagram post'"
        />
        <div
          v-if="showEngagement"
          class="instagram-feed-lightbox__engagement"
          :class="{ 'instagram-feed-lightbox__engagement--below': !!videoSrc }"
          :style="engagementStyle"
        >
          <span v-if="showLikes" :style="likesIconStyle">♥ {{ formatCount(post.likeCount) }}</span>
          <span v-if="showComments" :style="commentsIconStyle">💬 {{ formatCount(post.commentsCount) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstagramFeedPostLightbox',
  data() {
    return {
      visible: false,
      post: null,
      imageSrc: '',
      showEngagement: true,
      showLikes: true,
      showComments: true,
      engagementStyle: {},
      likesIconStyle: {},
      commentsIconStyle: {},
      videoSrc: '',
      onKeydown: null,
    };
  },
  mounted() {
    if (this.$el && this.$el.parentNode !== document.body) {
      document.body.appendChild(this.$el);
    }
  },
  beforeDestroy() {
    this.unbindEscape();
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  methods: {
    open(post, options) {
      const opts = options || {};
      this.post = post || null;
      this.imageSrc = opts.imageSrc || '';
      this.showEngagement = opts.showEngagement !== false;
      this.showLikes = opts.showLikes !== false;
      this.showComments = opts.showComments !== false;
      this.engagementStyle = opts.engagementStyle || {};
      this.likesIconStyle = opts.likesIconStyle || { color: '#FFFFFF' };
      this.commentsIconStyle = opts.commentsIconStyle || { color: '#FFFFFF' };
      this.videoSrc = this.resolveVideoSrc(this.post);
      this.visible = !!this.post && (!!this.imageSrc || !!this.videoSrc);
      if (this.visible) {
        this.bindEscape();
        document.body.style.overflow = 'hidden';
      }
    },
    resolveVideoSrc(post) {
      const type = post && post.mediaType;
      if (type !== 'VIDEO' && type !== 'REELS') {
        return '';
      }
      return post.mediaUrl || '';
    },
    pauseVideo() {
      const video = this.$refs.lightboxVideo;
      if (video && typeof video.pause === 'function') {
        video.pause();
      }
    },
    close() {
      this.pauseVideo();
      this.visible = false;
      this.post = null;
      this.videoSrc = '';
      this.unbindEscape();
      document.body.style.overflow = '';
    },
    bindEscape() {
      this.unbindEscape();
      this.onKeydown = (event) => {
        if (event.key === 'Escape' || event.keyCode === 27) {
          this.close();
        }
      };
      document.addEventListener('keydown', this.onKeydown);
    },
    unbindEscape() {
      if (this.onKeydown) {
        document.removeEventListener('keydown', this.onKeydown);
        this.onKeydown = null;
      }
    },
    formatCount(value) {
      const n = Number(value) || 0;
      if (n >= 1000000) {
        return (n / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
      }
      if (n >= 1000) {
        return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
      }
      return String(n);
    },
  },
};
</script>

<style>
.instagram-feed-lightbox {
  position: fixed;
  inset: 0;
  z-index: 10050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.72);
  box-sizing: border-box;
}
.instagram-feed-lightbox__dialog {
  position: relative;
  max-width: min(920px, 92vw);
  max-height: 90vh;
  width: auto;
  background: #111;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.45);
}
.instagram-feed-lightbox__image,
.instagram-feed-lightbox__video {
  display: block;
  max-width: 92vw;
  max-height: 90vh;
  width: auto;
  height: auto;
  object-fit: contain;
  vertical-align: middle;
  background: #000;
}
.instagram-feed-lightbox__close {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
  color: #111;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 2px;
}
.instagram-feed-lightbox__engagement {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  gap: 28px;
  padding: 20px 16px 24px;
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.55));
  pointer-events: none;
}
.instagram-feed-lightbox__engagement--below {
  position: static;
  background: #111;
  padding: 12px 16px 16px;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/InstagramFeed/PostLightbox.vue